"use client";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { getApiUrl } from "../hooks/api";

class TokenRefreshError extends Error {
  constructor(message) {
    super(message);
    this.name = "TokenRefreshError";
  }
}

const newIsTokenValid = (token, refreshToken) => {
  if (!token && !refreshToken) return false;

  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    const tokenValid = decodedToken.exp > currentTime;
    if (tokenValid) return true;
    const decodedRefreshToken = jwtDecode(refreshToken);
    if (!decodedToken.exp && !decodedRefreshToken.exp) return false;
    return decodedRefreshToken.exp > currentTime;
  } catch (error) {
    console.error("Error decoding token:", error);
    return false;
  }
};

const isTokenValid = token => {
  if (!token) return false;

  try {
    const decodedToken = jwtDecode(token);
    if (!decodedToken.exp) return false;
    const currentTime = Date.now() / 1000;
    return decodedToken.exp > currentTime;
  } catch (error) {
    console.error("Error decoding token:", error);
    return false;
  }
};

export const refreshToken = async refreshToken => {
  if (!isTokenValid(refreshToken)) {
    localStorage.clear();
    window.location.href = "/signin";
  }
  const apiUrl = getApiUrl();
  const tokenEndpoint = `${apiUrl}/auth/refresh-token`;

  const payload = {
    token: refreshToken
  };

  try {
    const response = await axios.post(tokenEndpoint, payload, {
      headers: {
        "Content-Type": "application/json"
      }
    });

    return {
      access: response.data.token.access,
      refresh: response.data.token.refresh
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new TokenRefreshError(
        error.response ? error.response.data : error.message
      );
    } else {
      window.location.href = "/signin";
      throw new TokenRefreshError(`Error refreshing token: ${error}`);
    }
  }
};

const getValidToken = async currentTokens => {
  if (isTokenValid(currentTokens.access)) {
    return currentTokens;
  }

  const newTokens = await refreshToken(currentTokens.refresh);
  return newTokens;
};

export { isTokenValid, getValidToken, newIsTokenValid };
